import { Injectable, Inject, forwardRef } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AslibModalService, AslibModalComponent } from '@aslib/modal';

@Injectable()
export class ErrorService {
  private readonly aslibModal: AslibModalComponent;

  constructor(
    // @Inject(forwardRef(() => AslibModalService))
    private readonly aslibModalService: AslibModalService
  ) {
    this.aslibModal = new AslibModalComponent(this.aslibModalService);
  }

  public handle(ret: HttpErrorResponse) {

    console.log('ret handle: ', ret);
  }

  /**
   * message
   * @param _title
   * @param _text
   * @param _type
   */
  private message(_title: string, _text: string, _type: string) {
    this.aslibModal.open({
      title: _title,
      text: _text,
      type: _type,
      backdrop: 'static'
    });
  }
  
}



// WEBPACK FOOTER //
// ./src/app/services/error.service.ts